import {Component, OnInit, OnDestroy, ViewChild}    from '@angular/core';
import {FormBuilder, FormGroup, Validators}         from "@angular/forms";
import {NgbActiveModal}                             from "@ng-bootstrap/ng-bootstrap";

import {College}                                    from "../../services/college/college";
import {CollegeService}                             from "../../services/college/college.service";
import {Message}                                    from "../../services/message/message";
import {MessageEntry}                               from "../../services/message/message-entry";
import {Permissions}                                from "../../services/permissions/permissions";

import {Subscription}                               from "rxjs/Subscription";

@Component({
	selector: 'app-college-admin',
	templateUrl: './college-admin.component.html',
	styleUrls: ['./college-admin.component.css']
})
export class CollegeAdminComponent implements OnInit, OnDestroy {

	message:Message;
	college: College;
	collegeDelete:Subscription;
	tForm: FormGroup;



	/**
	 * Initialize the object.
	 *
	 * @param {NgbActiveModal} activeModal       Used to close the page.
	 * @param {FormBuilder} fb                   Used to create the page objects.
	 * @param {CollegeService}  collegeService   Used when modifying College objects.
	 */
	constructor(
		public activeModal: NgbActiveModal,
		private fb: FormBuilder,
		private collegeService: CollegeService,
	) {}


	/**
	 * Initialize the FormBuilder and send the 'Ready' message.
	 */
	ngOnInit() {

		// Initialize the data structure for the page.
		this.tForm = this.fb.group({
			name: ['', [Validators.required,Validators.minLength(1), Validators.maxLength(32),]],
			id: [-1, [Validators.required, Validators.min(-1)]],
		});

		// Set up the message window with an initial message.
		let me:MessageEntry = new MessageEntry();
		me.message = 'Ready';
		me.level = 1;
		this.message = new Message(me);
		this.message.show();

	}


	/**
	 * Unsubscribe to avoid memory leaks.
	 */
	ngOnDestroy() {

		if (this.collegeDelete) {
			this.collegeDelete.unsubscribe();
		}

	}


	/**
	 * Lets me talk to the College typeahead.
	 */
	@ViewChild('collegeTypeahead')
	collegeTypeahead: any;


	/**
	 * Fill the fields with default data.
	 */
	clear():void {

		this.tForm.controls['name'].setValue('');
		this.tForm.controls['id'].setValue(-1);
		this.collegeTypeahead.searchFailed = false;
		this.collegeTypeahead.searching = false;
		this.collegeTypeahead.typeaheadCollegeInput.nativeElement.value = '';

		// Notify the user.
		let me:MessageEntry = new MessageEntry();
		me.message = 'Field cleared';
		me.level = 1;
		this.message.add(me, true);
		this.message.show();

	}


	/**
	 * Delete the current item.
	 */
	deleteCollege():void {

		// Give them the option to cancel.
		if (! window.confirm('Are you sure you want to delete this college?')) {
			return;
		}

		// 275 is the ID of the 'None' choice.
		if (0 >= this.tForm.controls['id'].value || 275 == this.tForm.controls['id'].value) {

			this.clear();
			this.collegeTypeahead.typeaheadCollegeInput.nativeElement.value = '';
			return;

		}

		let collegeName:string = this.collegeTypeahead.typeaheadCollegeInput.nativeElement.value;

		if (this.collegeDelete) {

			this.collegeDelete.unsubscribe();

		}

		this.collegeDelete = this.collegeService.deleteCollege(this.tForm.controls['id'].value).subscribe(

			() => {

				this.clear();

				// Notify the user.
				let me:MessageEntry = new MessageEntry();
				me.message = "'" + collegeName + "' deleted";
				me.level = 2;
				this.message.add(me, true);
				this.message.show();

			},
			() => {

				// Notify the user.
				let me:MessageEntry = new MessageEntry();
				me.message = "Failed to delete '" + collegeName + "'";
				me.level = 4;
				this.message.add(me, true);
				this.message.show();

			}

		);

	}


	/**
	 * Returns true if the Delete College button should be hidden.  This prohibits anyone from deleting
	 * the 'None' record or deletion of other records by non-administrators.
	 *
	 * @return {boolean} True if it should be hidden, false otherwise.
	 */
	hideDeleteButton():boolean {

		return (275 == this.tForm.controls['id'].value || -1 == this.tForm.controls['id'].value || (! Permissions.checkPermission(Permissions.SUPER_USER)));

	}


	/**
	 * Update everything when the selection changes.
	 *
	 * @param {any} event  The new College object.
	 */
	onCollegeChange(event: any): void {

		let college:College = new College(event);
		this.tForm.controls['name'].setValue(college.name);
		this.tForm.controls['id'].setValue(college.id);

		// This uses a reference to the typeahead to set the text box to the selected tag.
		this.collegeTypeahead.typeaheadCollegeInput.nativeElement.value = college.name;

		// Notify the user.
		let me:MessageEntry = new MessageEntry();
		me.message = "'" + college.name + "' chosen";
		me.level = 2;
		this.message.add(me, true);
		this.message.show();

	}


}



// WEBPACK FOOTER //
// ./src/app/admin/college/college-admin.component.ts